import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, of, switchMap } from 'rxjs';
import { HttpError, HttpResponse } from '@shared/utils/models/http.model';
import { PublicDemandFormService } from '../services/public-demand-form.service';
import { PublicDemandFormActions, PublicDemandFormResetActions } from '../actions/public-demand-form.actions';
import {
  PublicDemandFormDetails,
  SendPublicDemandFormResponse,
} from '@features/public-demand-form/utils/models/public-demand-form.model';

@Injectable()
export class PublicDemandFormEffects {
  private readonly publicDemandFormService = inject(PublicDemandFormService);
  private readonly actions$ = inject(Actions);

  validateDemandForm$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PublicDemandFormActions.validateDemandForm, PublicDemandFormResetActions.cancelPublicDemandFormActions),
      switchMap((action) =>
        action.type === PublicDemandFormResetActions.cancelPublicDemandFormActions.type
          ? of(PublicDemandFormResetActions.cancelPublicDemandFormActionsSuccess())
          : this.publicDemandFormService.validateDemandForm(action.userId).pipe(
              map((response: HttpResponse<PublicDemandFormDetails>) =>
                PublicDemandFormActions.validateDemandFormSuccess({ data: response.message })
              ),
              catchError((error: HttpError) => of(PublicDemandFormActions.validateDemandFormFailure({ error })))
            )
      )
    );
  });

  sendDemandForm$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PublicDemandFormActions.sendDemandForm),
      exhaustMap((action) =>
        this.publicDemandFormService.sendDemandForm(action.payload).pipe(
          map((response: HttpResponse<SendPublicDemandFormResponse>) =>
            PublicDemandFormActions.sendDemandFormSuccess({ data: response.message })
          ),
          catchError((error: HttpError) => of(PublicDemandFormActions.sendDemandFormFailure({ error })))
        )
      )
    );
  });
}
